(function () {
    'use strict';

    angular
        .module('app.memberAdmin')
        .constant('adjustScoresResolver', {
            individualId: getIndividualId            
        });

    getIndividualId.$inject = ['$transition$'];
    function getIndividualId($transition$) {
        return $transition$.params().individualId;
    }
 
})();
